import {Component, OnInit, Inject, ViewEncapsulation} from '@angular/core';
import {IPhotoContent} from '../../models/photo.model';
import {Title} from '@angular/platform-browser';
import {NewsService} from '../../service/news.service';
import {ActivatedRoute} from '@angular/router';
import {MatDialog} from '@angular/material/dialog';
import {dialogDataComponent} from '../modules/dialogData/dialogData.component';


@Component({
  selector: 'app-photo',
  templateUrl: './photo.component.html',
  styleUrls: ['./photo.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class PhotoComponent implements OnInit {
  PhotoContent: IPhotoContent[] = [];
  PhotoItem: IPhotoContent[] = [];
  name: string;
  color: string;

  constructor(
    private titleService: Title,
    private APIPhotoService: NewsService,
    private route: ActivatedRoute,
    public dialog: MatDialog
  ) {
    this.APIPhotoService.photoContent().subscribe(data => {
      data = data.filter((d) => d.categorycontent === this.route.url['_value'][1]['path']);
      const imageArray = data.reduce((acc, current) => {
        //
        const x = acc.find(item => item.categorycontent === current.categorycontent);
        if (!x) {
          return acc.concat([current]);
        } else {
          return acc;
        }
      }, []);
      this.PhotoItem = imageArray;
    });


    this.APIPhotoService.photoData().subscribe(response => {
      response = response.filter((d) =>
        d.category === this.route.url['_value'][1]['path']
      );

      for (let i = 0; i < response.length; i++) {
        const cat = response[i];

        if (this.PhotoItem.find((c) =>
          c.name === cat.name &&
          c.image === cat.image &&
          c.category === cat.category &&
          c.alt === cat.alt &&
          c.IClass === cat.IClass &&
          c.imageLg === cat.imageLg &&
          c.imageSm === cat.imageSm &&
          c.imageMd === cat.imageMd &&
          c.title === cat.title &&
          c.categorycontent === cat.categorycontent &&
          c.headerContent === cat.headerContent
        ) === undefined) {
          this.PhotoItem.push({
            name: cat.name,
            image: cat.image,
            category: cat.category,
            alt: cat.alt,
            IClass: cat.IClass,
            imageLg: cat.imageLg,
            imageSm: cat.imageSm,
            imageMd: cat.imageMd,
            title: cat.title,
            categorycontent: cat.categorycontent,
            headerContent: cat.headerContent
          });
        }
      }
    });
  }

  ngOnInit() {
  }

  openDialog(event): void {

    const dialogRef = this.dialog.open(dialogDataComponent, {

      panelClass: 'dialog-wrapper',
      data: {
        name: event.name,
        image: event.image,
        alt: event.alt,
        imageLg: event.imageLg
      }

    });


    dialogRef.afterClosed().subscribe(res => {
      this.color = res;
    });
  }

  public setTitle(newTitle: string) {
    this.titleService.setTitle(newTitle);
  }

  updateData(event: Event) {
    console.log('Click!', event);
    this.APIPhotoService.photoContent().subscribe(data => {
      data = data.filter((d) => d.category === this.route.url['_value'][1]['path']);
      console.log(data);
      this.PhotoItem = data;
    });
  }
}
